function resolveApiOrigin(configuredOrigin, browserOrigin) {
	const candidate = typeof configuredOrigin === 'string' && configuredOrigin.trim() !== ''
		? configuredOrigin.trim()
		: browserOrigin;

	let parsed;
	try {
		parsed = new URL(candidate);
	} catch (error) {
		throw new Error('Invalid API origin configuration.');
	}

	if (
		!['http:', 'https:'].includes(parsed.protocol)
		|| parsed.username !== ''
		|| parsed.password !== ''
		|| parsed.pathname !== '/'
		|| parsed.search !== ''
		|| parsed.hash !== ''
	) {
		throw new Error('Invalid API origin configuration.');
	}

	return parsed.origin;
}

function resolveApplicationPath(configuredPath, browserOrigin) {
	if (typeof configuredPath !== 'string' || !configuredPath.startsWith('/') || configuredPath.startsWith('//')) {
		throw new Error('Invalid application path configuration.');
	}
	const parsed = new URL(configuredPath, browserOrigin);
	if (
		parsed.origin !== browserOrigin
		|| parsed.username !== ''
		|| parsed.password !== ''
		|| parsed.search !== ''
		|| parsed.hash !== ''
		|| parsed.pathname !== configuredPath
	) {
		throw new Error('Invalid application path configuration.');
	}
	return configuredPath;
}

module.exports = { resolveApiOrigin, resolveApplicationPath };
